import React from 'react';
import Input from '../input';
import styles from './style';
function InputTransparent(props) {
    // Return
    return <Input multiline style={styles.transparentInput} {...props}/>;
}
export default InputTransparent;
